import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { UpdateMobileNoStackRoutes, UpdateMobileNoStackScreenProps } from '@/features/account-management/screens/update-mobile-no/type';
import { UpdateMobileNoWebOneScreen } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoWebOne.screen';
import { UpdateMobileNoNativeOneScreen } from '@/features/account-management/screens/update-mobile-no/UpdateMobileNoNativeOne.screen';

export const UpdateMobileNoConfirm: React.FC<UpdateMobileNoStackScreenProps<UpdateMobileNoStackRoutes.Confirm>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, func, onReturnData, refresh, onChangeView, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <UpdateMobileNoNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        record={record}
      />
    );
  }

  return (
    <UpdateMobileNoWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
      record={record}
    />
  );
};
